import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { TrendingTitles } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class TrendingTitlesService {

  constructor(private httpClient: HttpClient) { }

  public getTrendingTitles(daysOut: number): Observable<TrendingTitles[]> {
    const url = 'api/TrendingTitles/';
    return this.httpClient.post<TrendingTitles[]>(url, daysOut);
  }

  public getTrendingTitlesOnce(daysOut: number): Promise<TrendingTitles[]> {
    return this.getTrendingTitles(daysOut).toPromise();
  }
}
